module.exports = __webpack_public_path__ + "static/img/quanqiuying.816d1fa2.png";